import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import ScrollManager from "@/components/feature/ScrollManager";
import { HeroToneProvider } from "@/components/feature/HeroToneContext";
import { AuthProvider } from "@/components/feature/AuthContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <HeroToneProvider>
            <ScrollManager />
            <AppRoutes />
          </HeroToneProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
